/**
 *
 *
 * This component is used to show the user prescription appointment
 * and health record dropdown menueafter logged in on the header menue
 *
 *
 */

// import 'antd/dist/antd.css';
import React, { useState } from 'react';
import { Menu, Dropdown, Modal, Row, Col } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { LogoutOutlined, UserOutlined, CalendarOutlined, FolderOpenOutlined, ForkOutlined, IdcardOutlined, DownSquareOutlined } from '@ant-design/icons';
import { loginRedirectRequest } from '../Login/Actions';
import { BodyTextValue } from '../CommonText';
// import { FormattedMessage } from 'react-intl';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const MyAccount = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [openConfirmLogout, setOpenConfirmLogout] = useState(false);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;   

    const handleLogout = () => {
        // sessionStorage.clear();
        // localStorage.clear();
        // // Add any other logout-related actions here
        // dispatch(loginRedirectRequest(null));
        setOpenConfirmLogout(true);
    };

    const confirmLogout = () => {
        sessionStorage.clear();
        localStorage.clear();
        // Add any other logout-related actions here
        dispatch(loginRedirectRequest(null));
        setOpenConfirmLogout(false);
        navigate('/');
    };

    const cancelLogout = () => {
        setOpenConfirmLogout(false);
    };

    const menu = (
        <Menu style={{ marginTop: 20, width: '95%', marginRight : 10 }}>
            <Menu.Item>
                <Link to="/familytree">
                    <UserOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyFamily ? langdata.MyFamily : 'My Family'}`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/appointment">
                    <CalendarOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyAppointments ? langdata.MyAppointments : 'My Appointments' }`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/record">
                    <FolderOpenOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyHealthRecords ? langdata.MyHealthRecords : 'My Health Records' }`}/>
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/prescription">
                    <ForkOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyPrescriptions ? langdata.MyPrescriptions : 'My Prescriptions' }`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/mycheckups">
                    <FolderOpenOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyCheckup ? langdata.MyCheckup : 'My Checkups'}`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/profilefront">
                    <UserOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyProfile ? langdata.MyProfile : 'My Profile'}`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <Link to="/passport">
                    <IdcardOutlined /> {' '}
                    <BodyTextValue text={`${langdata.MyPassport ? langdata.MyPassport : 'My Passport'}`} />
                </Link>
            </Menu.Item>
            <Menu.Item>
                <div onClick={handleLogout}>
                    <LogoutOutlined /> {' '}
                    <BodyTextValue text={`${langdata.Logout ? langdata.Logout : 'Logout'}`} />
                </div>
            </Menu.Item>
        </Menu>
    );    

    return (
        <>
            <Dropdown overlay={menu} placement='bottom'>
                <span>
                    <BodyTextValue text={`${langdata.MyAccount ? langdata.MyAccount : 'My Account' }`} />{' '}
                    <DownSquareOutlined />
                </span>
            </Dropdown>
            <Modal title={langdata.Confirmlogout ? langdata.Confirmlogout : 'Confirm logout'} open={openConfirmLogout} onOk={confirmLogout} onCancel={cancelLogout}>
                <Row style={{
                    marginTop: '10px',
                    marginBottom: '10px',
                    background: '#FFFFFF',
                    alignItems: 'center'
                }} >
                    <Col span={24}>
                        {langdata.Areyousureyouwanttologoutofthesystem ? langdata.Areyousureyouwanttologoutofthesystem : 'Are you sure you want to logout of the system?' }
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

MyAccount.propTypes = {
    dispatch: PropTypes.func,
};

export default MyAccount;
